export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_OPEN_MODAL = "SET_OPEN_MODAL";
export const SET_EXT_EXCLUSION = "SET_EXT_EXCLUSION";


export const GET_EXT_EXCLUSIONS = "GET_EXT_EXCLUSIONS";
export const GET_EXT_EXCLUSIONS_SUCCESS = "GET_EXT_EXCLUSIONS_SUCCESS";
export const GET_EXT_EXCLUSIONS_FAILURE = "GET_EXT_EXCLUSIONS_FAILURE";

export const GET_EXT_EXCLUSION = "GET_EXT_EXCLUSION";
export const GET_EXT_EXCLUSION_SUCCESS = "GET_EXT_EXCLUSION_SUCCESS";
export const GET_EXT_EXCLUSION_FAILURE = "GET_EXT_EXCLUSION_FAILURE";

export const CREATE_EXT_EXCLUSION = "CREATE_EXT_EXCLUSION";
export const CREATE_EXT_EXCLUSION_SUCCESS = "CREATE_EXT_EXCLUSION_SUCCESS";
export const CREATE_EXT_EXCLUSION_FAILURE = "CREATE_EXT_EXCLUSION_FAILURE";

export const UPDATE_EXT_EXCLUSION = "UPDATE_EXT_EXCLUSION";
export const UPDATE_EXT_EXCLUSION_SUCCESS = "UPDATE_EXT_EXCLUSION_SUCCESS";
export const UPDATE_EXT_EXCLUSION_FAILURE = "UPDATE_EXT_EXCLUSION_FAILURE";

export const DELETE_EXT_EXCLUSION = "DELETE_EXT_EXCLUSION";
export const DELETE_EXT_EXCLUSION_SUCCESS = "DELETE_EXT_EXCLUSION_SUCCESS";
export const DELETE_EXT_EXCLUSION_FAILURE = "DELETE_EXT_EXCLUSION_FAILURE";

export const UPDATE_EXT_EXCLUSIONS_ORDER = "UPDATE_EXT_EXCLUSIONS_ORDER";
export const UPDATE_EXT_EXCLUSIONS_ORDER_SUCCESS = "UPDATE_EXT_EXCLUSIONS_ORDER_SUCCESS";
export const UPDATE_EXT_EXCLUSIONS_ORDER_FAILURE = "UPDATE_EXT_EXCLUSIONS_ORDER_FAILURE";